/**
 * Brazilian Portuguese strings for the `sections` namespace — the game-scoped section
 * pages (Jogador, Streamers) while they are still placeholders.
 *
 * Keys are in English (repo convention); values are the pt-BR copy shown to users.
 */
export const sections = {
  player: {
    title: 'Perfis de Jogador',
    text: 'Skills, XP e a evolução de qualquer aventureiro — com snapshots que crescem com o tempo.',
  },
  streamers: {
    title: 'Streamers BR',
    text: 'Quem está ao vivo em Gielinor, falando português.',
  },
  status: {
    buildingBadge: 'Em construção',
    buildingText: 'Esta ala do códice está sendo escrita. Volte em breve.',
    osrsBadge: 'Em breve',
    osrsText: 'O Old School chega depois do RS3 — a fundação multi-jogo já está pronta.',
  },
  backHome: 'Voltar ao início',
}
